import React from 'react';
import {
  History as AuditLogIcon,
  People as CustomersIcon,
  Dashboard as DashboardIcon,
  Palette as DesignsIcon,
  Inventory as InventoryIcon,
  Receipt as InvoicesIcon,
  ShoppingCart as OrdersIcon,
  ViewKanban as ProductionIcon,
  Assessment as ReportsIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import { UserRole } from '@core/enum/userRole';
import { NavItem } from '@core/interfaces';
import AuditLog from './pages/AuditLog';
import Customers from './pages/Customers';
import Dashboard from './pages/Dashboard';
import Designs from './pages/Designs';
import Inventory from './pages/Inventory';
import Invoices from './pages/Invoices';
import OrderDetail from './pages/OrderDetail';
import Orders from './pages/Orders';
import Production from './pages/Production';
import Reports from './pages/Reports';
import Settings from './pages/settings';

export const navItems: NavItem[] = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    subtitle: 'Overview of business performance and key activity',
    icon: React.createElement(DashboardIcon),
    component: Dashboard,
  },
  {
    path: '/customers',
    title: 'Customers',
    subtitle: 'Manage customers and their information',
    icon: React.createElement(CustomersIcon),
    component: Customers,
  },
  {
    path: '/orders',
    title: 'Orders',
    subtitle: 'Manage and track orders and requests',
    icon: React.createElement(OrdersIcon),
    component: Orders,
    children: [
      // {
      //   path: '/orders/add-order',
      //   title: 'Add Order',
      //   component: OrderForm,
      // },
      // {
      //   path: '/orders/:id/edit-order',
      //   title: 'Edit Order',
      //   component: OrderForm,
      // },
      {
        path: '/orders/:id',
        title: 'Order Details',
        component: OrderDetail,
      },
    ],
  },
  {
    path: '/production',
    title: 'Production',
    subtitle: 'Manage and monitor your production units',
    icon: React.createElement(ProductionIcon),
    component: Production,
  },
  {
    path: '/invoices',
    title: 'Invoices',
    subtitle: 'Manage billing and invoice generation',
    icon: React.createElement(InvoicesIcon),
    component: Invoices,
  },
  {
    path: '/designs',
    title: 'Designs',
    subtitle: 'Manage vestment design templates and concepts',
    icon: React.createElement(DesignsIcon),
    component: Designs,
  },
  {
    path: '/inventory',
    title: 'Inventory',
    subtitle: 'Manage inventory levels and stock movement',
    icon: React.createElement(InventoryIcon),
    component: Inventory,
  },
  {
    path: '/reports',
    title: 'Reports',
    subtitle: 'View analytics and reports for your business',
    icon: React.createElement(ReportsIcon),
    component: Reports,
  },
  {
    path: '/logs',
    title: 'Logs',
    subtitle: 'View system activity and change history',
    icon: React.createElement(AuditLogIcon),
    component: AuditLog,
    minRole: UserRole.SuperAdmin,
  },
  {
    path: '/settings/*',
    title: 'Settings',
    subtitle: 'Manage vestment, collar, fabric and color settings',
    icon: React.createElement(SettingsIcon),
    component: Settings,
  },
];
